import React from 'react';
import { Container, Navbar } from 'reactstrap';
import './Header.css';
import logo from '../SP.svg';

export function Header (props) {

    return (
        <header>
            <Navbar className="ng-white " light>
                <Container className="text-center justify-content-center border-bottom padding-15">
                    <img alt="Sportshouse" src={logo} style={{'width':'50%'}} />
                </Container>
            </Navbar>
        </header>
    );
}
